<template>
  <v-container id="admin-banner-table-wrapper" class="pa-0">
    <v-btn class="btn-primary mt-5 mb-3" @click="createClick"
      >Nový banner</v-btn
    >
    <banner-dialog
      ref="bannerActionDialog"
      :action="actionDialogType"
      :entityId="editId"
      @successEvent="loadData"
    ></banner-dialog>

    <v-data-table
      v-model="selected"
      :disable-pagination="false"
      :headers="headers"
      :items="items"
      hide-default-footer
      :page.sync="page"
      :items-per-page="10"
      @page-count="pageCount = $event"
      :single-select="false"
      :single-expand="false"
      item-key="pkid"
      :loading="loading"
      loadingText="Načítavam dáta ..."
    >
      <template v-slot:[`item.stav`]="{ item }">
        <v-switch
          @change="updateStatus(item.pkid, item.stav)"
          v-model="item.stav"
        ></v-switch>
      </template>

      <template v-slot:[`item.datum_do`]="{ item }">
        <span v-if="item.datum_do">{{ item.datum_do.formatDate() }}</span>
      </template>

      <template v-slot:[`item.akcie`]="{ item }">
        <v-menu
          content-class="admin-banner-table-menu"
          offset-x
          transition="slide-x-transition"
          left
          open-on-hover
          nudge-left="5"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list id="admin-banner-table-menu-list" elevation="1">
            <v-list-item
              link
              dense
              v-for="(m, i) in menu"
              :key="i"
              :class="m.color"
              @click="actionClick(m.nazov, item.pkid)"
            >
              <v-list-item-icon class="mr-4">
                <v-icon v-text="m.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ m.nazov }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import protectedAxios from '../../auth/axios';
import Status from '../basic/Status.vue';
import BannerDialog from '../administracia/BannerDialog.vue';
import Utils from '../../plugins/utils';
export default {
  components: { Status, BannerDialog, Utils },
  methods: {
    loadData(filter) {
      this.editDialog = false;
      this.createDialog = false;
      this.editId = 0;
      this.loading = true;
      this.items = [];
      this.selected = [];
      this.expanded = [];
      this.transitioned = [];
      this.closeTimeouts = [];

      protectedAxios
        .get(`banner`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => (this.items = res.data ? res.data : []))
        .catch(e => {
          console.error(e);
          this.items = [];
        })
        .finally(() => (this.loading = false));
    },

    createClick() {
      this.actionDialogType = 'create';
      this.$refs.bannerActionDialog.openDialog();
    },

    actionClick(akcia, pkid) {
      switch (akcia) {
        case 'Zmazať':
          this.deleteBanner(pkid);
          break;
        case 'Upraviť':
        this.$refs.bannerActionDialog.openDialog();
          this.actionDialogType = 'update';
          this.editId = pkid;
          break;
        default:
          break;
      }
    },

    deleteBanner(id) {
      protectedAxios
        .delete('banner/' + id)
        .then(res => {
          this.items = this.items.filter(x => x.pkid != id);
        })
        .catch(e => {
          console.error(e);
        });
    },

    updateStatus(id, status) {
      protectedAxios
        .put(
          'banner/status/' + id,
          { stav: status },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {})
        .catch(e => {
          console.error(e);
        });
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      actionDialogType: '',
      editId: 0,
      page: 1,
      pageCount: 0,
      selected: [],
      loading: false,
      renderKey: 0,
      menu: [
        { nazov: 'Upraviť', icon: 'mdi-pencil-outline' },
        {
          nazov: 'Zmazať',
          icon: 'mdi-trash-can-outline',
          color: 'negative-500',
        },
      ],
      headers: [
        { text: 'Stav', value: 'stav', sortable: true },
        { text: 'Názov', value: 'nazov' },
        { text: 'Titulok', value: 'text_vlavo_titulok' },
        { text: 'Dátum do', value: 'datum_do' },
        { text: 'Akcie', value: 'akcie', sortable: false },
      ],
      items: [],
    };
  },
};
</script>
